















































































import { defineComponent, ref, useContext } from '@nuxtjs/composition-api';
import { SfAccordion, SfButton, SfInput, SfTextarea } from '@storefront-ui/vue';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { email, min, required } from 'vee-validate/dist/rules';
import AccordionItemToggleIcon from '~/components/General/AccordionItemToggleIcon.vue';
import SvgImage from '~/components/General/SvgImage.vue';
import HTMLContent from '~/components/HTMLContent.vue';
import { useApi, useUiNotification } from '~/composables';
import { buildSeoHead } from '~/helpers/buildSeoHead';
import contactGql from '~/modules/customer/queries/contact.gql';
import { ContactResponse } from '~/modules/customer/types/form';

export default defineComponent({
  name: 'CustomerService',
  components: { SfAccordion, SfInput, SfButton, SfTextarea, HTMLContent, ValidationObserver, SvgImage, ValidationProvider, AccordionItemToggleIcon },
  setup() {
    extend('required', {
      ...required,
      message: 'This field is required',
    });
    extend('min', {
      ...min,
      message: 'The field should have at least {length} characters',
    });
    extend('email', {
      ...email,
      message: 'Invalid email',
    });

    const { app } = useContext();
    const { query } = useApi();
    const { send: sendNotification } = useUiNotification();

    const questions = [
      {
        title: 'Vilka sköter om provtagning och analysering?',
        text: '<p>Det är de vanliga vårdcentral- och sjukhuslaboratorierna som även sköter Blodkollens provtagning och analysering vilket betyder att kvaliteten är densamma som hos någon annan vårdgivare. Blodkollen samarbetar både med Karolinska Universitetsjukhusets laboratorier,&nbsp;Unilabs laboratoriemedicin samt Aleris Medilab&nbsp;vilket garanterar samma kvalitet på provtagning, analys och svar som hos dina normala vårdgivare.</p>',
      },
      {
        title: 'Vilka har tillgång till mina analysresultat?',
        text: '<p>Vi dokumenterar i vår journal vilket prov som du beställt och dess resultat. Dessa journaler går inte att komma åt om du inte ger aktivt medgivande till det. Det finns även möjlighet att spärra svaren helt.<br>\nSvaren går att skriva ut och ta med till din läkare och då vi använder samma analyslaboratorier som den ordinarie vården så har de samma kvalitet och tillförlitlighet som hos din läkare.</p>',
      },
      {
        title: 'Varför kan jag inte bara gå till Vårdcentralen?',
        text: '<p>I dagens offentliga vård måste du vara oftast vara sjuk eller visa symptom på sjukdom för att få analysera dina blodvärden.<br>\n<br>\nHos vårdcentralen är vägen till att få reda på dina blodvärden lång, du måste först vänta på telefontid, sitta i telefonkö, vänta på läkartid, betala 200 kronor för att därefter få sitta i väntrum med sjuka patienter för att slutligen få träffa en ofta stressad och tidspressad doktor. När du äntligen får träffa denna läkare riskerar du dessutom att bli nekad de analyser du önskar då din läkare inte finner dem nödvändiga på grund av att <u>du inte visar några påtagliga symptom som ger vården skyldighet att betala för dem.</u></p>\n<p>Blodkollen ger dig möjligheten att själv välja vad du vill analysera utan att någon ifrågasätter varför. Om du vet vad du är intresserad av att analysera finns ett flertal analyspaket att välja på. Din beställning tar endast tre minuter och kan göras via din mobil, dator eller läsplatta närhelst du har tid. Provtagningen sker på samma enheter som din vårdcentral använder sig av och de flesta enheter arbetar enligt "drop in" metoden så att du själv ska kunna välja tidpunkten för din provtagning. Några undantag kan finnas men det förmedlas då vi din beställning.<br>\nMed Blodkollen får du dessutom alltid resultatet i din hand, något som inte alltid är självklart inom den offentliga vården. Resultatet kommer läkargranskat och smidigt till en egen personlig och konfidentiell journalsida, inom kortast möjliga tid. De flesta prover är klara redan efter 24 timmar men en del analyser tar längre tid på grund av analysfrekvensen hos våra laboratorier. Tillsammans med ditt resultat för du även förslag på hälsooptimering i de fall det är möjligt.</p>\n<p>Vid avvikande resultat ifrån normalvärdena hänvisas du till din husläkare.</p>\n<p>Blodkollens mål är delvis att vara ett redskap för individer som vill känna till sina möjligheter och begränsningar för att uppnå maximalt resultat i en aktiv livsstil. Vi vill också vara ett komplement till din vårdcentral och ge dig en chans att arbeta proaktivt med din hälsa för att undvika framtida vällevnadssjukdomar.<br>\n&nbsp;</p>',
      },
      {
        title: 'När kan man gå till labbet?',
        text: '<p><strong>På vardagar finns din remiss på din&nbsp;valda provtagningsenhet redan inom en halvtimme.</strong><br>\nDet finns många provtagningsenheter att välja på och de arbetar oftast enligt drop in-metod vilket ger dig en frihet att både välja vilken provtagningsenhet du vill samt när du vill ta ditt prov. Några av dessa är dock öppna endast mellan 08.00-11.00. Undantag från drop in är provtagning via ENCIA´s mottagningar&nbsp;då du måste boka tid innan. kontaktuppgifter erhålls i det mail som bekräftar ditt köp.&nbsp;<br>\nTänk dock på att många av våra analyser kräver provtagning innan klockan 10.00 och andra att de ska tas fastande. Om något av detta krävs så anges även detta i det mejl som bekräftar ditt köp. Det står även angivet på analyspaketens sidor.</p>',
      },
      {
        title: 'Måste man ha ett svenskt personnummer?',
        text: '<p>Ja. De olika system som används för analys fungerar endast med ett svenskt personnummer.</p>',
      },
      {
        title: 'Kan jag dela en beställning på olika tillfällen?',
        text: '<p>Nej tyvärr.<br>\nDå en remiss genereras kopplas alla analyser samman via ett kontrollnummer och kan då ej separeras. Vill du ta prover vid olika tillfällen måste två separata beställningar göras.</p>',
      },
      {
        title: 'Kan jag beställa till fler personer i samma beställning?',
        text: '<p>Nej, varje beställning är kopplad till det personnummer som uppges, detta betyder att varje enskild person som ska göra en provtagning också måste göra en egen beställning, alltså uppge personnummer, mailadress, telefonnummer och adress. Detta för att vi ska kunna hålla en hög säkerhet och bibehålla de sekretesskrav som varje läkare har. Är det ett flertal personer som beställer på samma dator är det viktigt att beställningen görs i urloggat läge då beställningen annars hamnar på den som för stunden är inloggad.&nbsp;<br>\n&nbsp;</p>',
      },
      {
        title: 'Jag har beställt men inte fått något bekräftelsemail?',
        text: '<p>Det är viktigt att du erhåller all information vid ditt köp.<br>\nBeroende på vilka inställningar den server du använder har kan mail ibland inte komma fram. Titta bland spam eller skräppost&nbsp;och återkom till oss om du fortfarande inte erhållit något mail.</p>\n<p>&nbsp;</p>',
      },
      {
        title: 'Hur länge gäller min remiss?',
        text: '<p>Din remiss ligger i tre månader sedan måste man höra av sig för att kontrollera att remissen ligger kvar.</p>',
      },
      {
        title: 'Hur får jag svaren?',
        text: '<p>Svarstiden beror av hur frekvent analyserna genomförs på våra samarbetande laboratorier. Vissa görs redan samma dag varpå ditt svar kan erhållas inom några få timmar, mer <u>ovanliga analyser</u>&nbsp;kan ta upp till en månad. Om analysfrekvensen på ditt önskade prov är låg så nämns det på analysens sida.<br>\n<br>\nEfter uppskattningsvis 48 timmar&nbsp;så har samtliga analyssvar kommit. Du får först ett SMS eller ett mail som talar om att dina resultat börjar komma in. Resultatet ser du genom att logga in på din personliga och konfidentiella journalsida. Svaren är prydligt redovisande analys för analys, resultat och referensvärden. Tillsammans med ditt resultat får du även förslag på hälsooptimering i de fall det är möjligt. Vi samarbetar med läkare, personliga tränare och näringsfysiologer utöver vår egen kompetens inom träningsforskning och laboratoriemedicin.</p>\n<p>Vid avvikande resultat ifrån normalvärdena hänvisas du till din husläkare. Vi samarbetar även med MediCheck för att kunna erbjuda snabbare kontakt med specialister.</p>',
      },
      {
        title: 'Har ni vanlig sjukhussekretess?',
        text: '<p>Ja, Blodkollen följer samma lagar och regler avseende sekretess som vårdcentraler och sjukhus.</p>',
      },
      {
        title: 'Har ni någon åldersgräns?',
        text: '<p>Generellt har vi en åldersgräns på 18 år. Detta kan dock via dialog med oss sänkas till 13 år beroende på syfte och val av analyser samt om egen läkarkontakt finns.</p>',
      },
    ];

    const isLoading = ref(false);
    const halfLength = Math.floor(questions.length / 2);

    const form = ref({
      name: '',
      email: '',
      comment: '',
    });

    const submitCustomerInquire = async () => {
      isLoading.value = true;
      const { data } = await query<ContactResponse>(contactGql, form.value);
      if (data.contact) {
        sendNotification({
          id: Symbol('contact_success'),
          message: app.i18n.t('Message sent') as string,
          persist: true,
          title: 'Contact success',
          type: 'success',
          icon: 'check',
        });
      } else {
        sendNotification({
          id: Symbol('contact_error'),
          message: app.i18n.t('Something went wrong') as string,
          persist: false,
          title: 'Contact error',
          type: 'danger',
          icon: 'error',
        });
      }
      isLoading.value = false;
    };

    return { questions, form, halfLength, submitCustomerInquire, isLoading };
  },
  head: buildSeoHead({ title: 'Kundtjänst' }),
});
